import styled from '@emotion/styled';
import { mq } from '@styles/helpers';
import { Devices } from '@styles/tokens';

export const Wrapper = styled.div<{ start?: boolean }>`
  padding: 0 30px;
`;

export const Container = styled.div`
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ImageContainer = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 1 / 1;
  max-width: 200px;
  margin: 0 auto 20px auto;
`;

export const TopText = styled.div`
  color: #4d4d4d;
  font-size: 30px;
  font-weight: 600;
  padding: 50px;
  text-align: center;

  ${mq(Devices.mobile)} {
    padding: 6vw 2vw;
    font-size: 6.5vw;
    min-height: 12vh;
  }
`;

export const BottomText = styled.div`
  color: #fff;
  font-size: 30px;
  padding: 20px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;

  ${mq(Devices.mobile)} {
    padding: 6vw 2vw;
    font-size: 5.5vw;
  }

  
`;

export const NavContainer = styled.div`
    position: absolute;
    top:30px;
    left:30px;
    height:24px;
    display:flex;
    align-items: center;
    gap:20px;

    svg{
        height:100%;
        path{
            fill:${props => props.theme.colors.placeholderColor};
        }
    }
`; 

export const MiddleContainer = styled.div`
  background: #fff;
  border-radius: 30px;
  overflow: hidden;
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;

  svg {
    width: 30%;
  }

  p {
    font-size: 22px;
    font-weight: 600;
    margin-top: 10px;
    text-align: center;
    padding: 0 10px;
    svg {
      width: 5%;
    }
  }
  span {
    font-size: 18px;
  }

  ${mq(Devices.mobile)} {
    svg {
      width: 30%;
    }

    p {
      font-size: 6vw;
      font-weight: 600;
      margin-top: 10px;
    }
    span {
      font-size: 5.5vw;
    }
  }
`;

export const QRContainer = styled.div`
  border-radius: 30px;
  overflow: hidden;
  width: 100%;
  max-width: 400px;
  aspect-ratio: 1 / 1.3;
  background: #fff;
  position: relative;

  > section > div {
    position: unset !important;
  }
`;

export const CodeContainer = styled.div`
  width: 100%;
  max-width: 400px;
  position: relative;
`;

export const QRContainerBorder = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  border: 20px solid #2879827d;
  z-index: 10;
  border-radius: 30px;
`;


export const InfoContainer = styled.div`
  position: relative;
   background: #fff;
    border-radius: 6px;
    overflow: hidden;
    width: 100%;
    max-width: 400px;
    display: flex;
    flex-direction: column;
    padding: 20px;
    margin-top: 40px;
    min-height:210px;
`;

export const RewardInfo = styled.div`
  margin-top: 20px;
   display:grid;
   grid-template-columns: 2fr 1fr;

   h2{
        grid-column: 1 / span 2;
        font-size: 20px;
        font-weight: 500;
    }
  
    span{
        font-size: 18px;
    
      :nth-of-type(2){
        grid-column: 1 / span 2;
      }
    }
  
    p{
        margin-left: auto;
        font-size: 16px;
        display:flex;
        align-items: center;
        svg{
          margin-left: 4px;
          width:20px;
        }
    }
   

  ${mq(Devices.mobile)} {
    h2{
        font-size: 6vw;
    }

    span{
        font-size: 5vw;
    }

    p{
        font-size: 5vw;
        svg{
          width:5vw;
        }
    }
  }

`;

export const UserTitle = styled.span`
  font-size: 26px;
  font-weight: 700;
  text-align: center;
  
  ${mq(Devices.mobile)}{
    font-size: 8vw;

  }
`;

export const B = styled.button`
  background: ${props => props.theme.colors.placeholderColor};
  padding:12px 0;
  width:200px; 
  border-radius: 4px;
  margin-top: 20px;
  margin-bottom: 30px;
  color:#fff;
  font-size: 22px;

  ${mq(Devices.mobile)} {

    font-size: 7vw;
    width:100%; 
  }
`;